<div *ngIf="loader" class="fixed inset-0 flex items-center justify-center bg-white z-50">
  <div class="text-center">
    <div class="animate-spin rounded-full h-16 w-16 border-b-2 border-gray-900 mx-auto"></div>
    <p class="mt-4 text-gray-600 text-sm">
      Loading Result...
    </p>
  </div>
</div>
<div *ngIf="!loader">
  <div *ngIf="results?.student_result_details; else noDataToShow">
    <!-- Session id > 14 : first design (monospace / Times New Roman, labels: Registration Id / Student Name) -->
    <ng-container *ngIf="useFirstDesign">
      <div class="container">
        <div class="header" style="margin-bottom: 5px; font-family: 'Helvetica', 'Times New Roman', monospace;">
          <span style="font-weight: 600; font-size:1rem;">{{ results?.student_data?.pcb_mapping?.alias_1 || results?.student_data?.pcb_mapping?.alias_2 || results?.student_data?.pcb_mapping?.alias_3 }}</span>
          <div style="padding-top: 4px;"></div>
          <span style="font-weight: 600; font-size: 0.9rem;">
            Examination ({{ results?.student_result_details?.exam_month }} - {{ results?.student_result_details?.exam_year }})
          </span>
          <div style="padding-top: 2px;"></div>
          <span>
            <strong style="font-size: 0.8rem;"> {{ results?.student_result_details?.semester_year }} (Batch : {{ results?.student_result_details?.batch }})</strong>
          </span>
        </div>
        <div class="info-section">
          <div class="info-left">
            <p style="margin-left: 4px">
              <span style="margin-right: 30px; font-size: 12px; font-family: 'Helvetica', 'Arial', sans-serif; font-weight: 600">Registration Id</span>
              <span style="font-size: 12px; font-weight: bold">:</span>
              <span style="font-size: 12px; font-family: 'Helvetica', 'Arial', sans-serif; font-weight: 600">&nbsp;{{ results?.student_data?.admission_no }}</span>
            </p>
            <p style="margin-left: 4px">
              <span style="margin-right: 34px; font-size: 12px; font-family: 'Helvetica', 'Arial', sans-serif; font-weight: 600">Student Name</span>
              <span style="font-size: 12px; font-weight: bold">:</span>
              <span style="font-size: 12px; font-family: 'Helvetica', 'Arial', sans-serif; font-weight: 600; text-transform: uppercase;">&nbsp;{{ results?.student_result_details?.student_name }}</span>
            </p>
            <p style="margin-left: 4px">
              <span style="margin-right: 32px; font-size: 12px; font-family: 'Helvetica', 'Arial', sans-serif; font-weight: 600">Father's Name</span>
              <span style="font-size: 12px; font-weight: bold">:</span>
              <span style="font-size: 12px; font-family: 'Helvetica', 'Arial', sans-serif; font-weight: 600; text-transform: uppercase;">&nbsp;{{ results?.student_result_details?.student_father_name }}</span>
            </p>
            <p style="margin-left: 4px">
              <span style="margin-right: 28px; font-size: 12px; font-family: 'Helvetica', 'Arial', sans-serif; font-weight: 600">Mother's Name</span>
              <span style="font-size: 12px; font-weight: bold">:</span>
              <span style="font-size: 12px; font-family: 'Helvetica', 'Arial', sans-serif; font-weight: 600; text-transform: uppercase;">&nbsp;{{ results?.student_result_details?.student_mother_name }}</span>
            </p>
          </div>
          <div style="margin-top: 15px"><svg #barcode></svg></div>
        </div>
        <table class="result-table">
          <thead>
          <tr>
            <th style="width: 72px; text-align: left; vertical-align: top;"><p style="margin: 2px; font-size: 10px; font-weight: bolder">Subject Code</p></th>
            <th style="width: 210px; text-align: left; vertical-align: top;"><p style="margin: 2px; font-size: 10px; font-weight: bolder">Subject Name</p></th>
            <th style="width: 50px; text-align: center; vertical-align: top;"><p style="margin: 2px; font-size: 10px; font-weight: bolder">CREDIT</p></th>
            <th style="width: 50px; text-align: center; vertical-align: top;"><p style="margin: 2px; font-size: 10px; font-weight: bolder">GRADE</p></th>
            <th style="width: 50px; text-align: center; vertical-align: top;"><p style="margin: 2px; font-size: 10px; font-weight: bolder">GRADE POINT</p></th>
            <th style="width: 50px; text-align: center; vertical-align: top;"><p style="margin: 2px; font-size: 10px; font-weight: bolder">TOTAL GRADE POINT</p></th>
            <th style="width: 55px; text-align: center; vertical-align: top;"><p style="margin: 2px; font-size: 10px; font-weight: bolder">STATUS</p></th>
          </tr>
          </thead>
          <tbody>
          <tr *ngFor="let subject of results?.student_result_details?.student_result">
            <td style="text-align: left"><p style="font-family: 'Times New Roman', 'Courier New', monospace; margin: 2px; font-size: 10px; font-weight: bold;">{{ subject?.code }}</p></td>
            <td style="text-align: left"><p style="font-family: 'Times New Roman', 'Courier New', monospace; margin: 2px; font-size: 10px; font-weight: bold;">{{ subject?.name }}</p></td>
            <td style="text-align: center"><p style="font-family: 'Times New Roman', 'Courier New', monospace; margin: 2px; font-size: 10px; font-weight: bold;">{{ subject?.credit }}</p></td>
            <td style="text-align: center"><p style="font-family: 'Times New Roman', 'Courier New', monospace; margin: 2px; font-size: 10px; font-weight: bold;">{{ subject?.grade?.trim() }}</p></td>
            <td style="text-align: center"><p style="font-family: 'Times New Roman', 'Courier New', monospace; margin: 2px; font-size: 10px; font-weight: bold;">{{ subject?.grade_points }}</p></td>
            <td style="text-align: center"><p style="font-family: 'Times New Roman', 'Courier New', monospace; margin: 2px; font-size: 10px; font-weight: bold;">{{ subject?.total_grade_points }}</p></td>
            <td style="text-align: center"><p style="font-family: 'Times New Roman', 'Courier New', monospace; margin: 2px; font-size: 10px; font-weight: bold;">{{ subject?.status }}</p></td>
          </tr>
          <tr>
            <td colspan="2" style="border-right: none !important;">
              <p style="font-family: 'Times New Roman', 'Courier New', monospace; margin: 2px; font-size: 10px; font-weight: bolder; text-align: left;">Total</p>
            </td>
            <td style="border-left: none !important; border-right: none !important;">
              <p style="font-family: 'Times New Roman', 'Courier New', monospace; margin: 2px; font-size: 10px; font-weight: 600">{{ results?.student_result_details?.grand_total_credit }}</p>
            </td>
            <td style="border-left: none !important; border-right: none !important;"></td>
            <td style="border-right: none !important; border-left: none !important;">
              <p style="font-family: 'Times New Roman', 'Courier New', monospace; margin: 4px; font-size: 10px; font-weight: 600">{{ results?.student_result_details?.grand_total_grade_point }}</p>
            </td>
            <td style="border-right: none !important; border-left: none !important;">
              <p style="font-family: 'Times New Roman', 'Courier New', monospace; margin: 4px; font-size: 10px; font-weight: 600">{{ results?.student_result_details?.grand_total_total_grade_point }}</p>
            </td>
            <td style="border-left: none !important;"></td>
          </tr>
          </tbody>
        </table>
        <div class="footer" style="margin-top: 0 !important;">
          <p style="text-align: right; margin-right: 10px">
            <span style="font-family: 'Times New Roman', 'Courier New', monospace; font-size: 10px; font-weight: bold;">SEMESTER GRADE POINT AVERAGE (SGPA)</span>:
            <span style="font-family: 'Times New Roman', 'Courier New', monospace; font-size: 10px; font-weight: bold;">{{ results?.student_result_details?.sgpa }}</span>
          </p>
          <p style="text-align: right; margin-right: 10px">
            <span style="font-family: 'Times New Roman', 'Courier New', monospace; font-size: 10px; font-weight: bold;">CUMULATIVE GRADE POINT AVERAGE (CGPA)</span>:
            <span style="font-family: 'Times New Roman', 'Courier New', monospace; font-size: 10px; font-weight: bold;">{{ results?.student_result_details?.cgpa }}</span>
          </p>
        </div>
      </div>
    </ng-container>
    <!-- Session id <= 14 : second design (serif / Times New Roman + TlwgTypewriter values, labels: Registration ID / Name) -->
    <ng-container *ngIf="!useFirstDesign">
      <div class="container">

        <!-- ── Header ─────────────────────────────────────────────── -->
        <div class="header" style="font-family: 'Times New Roman', Times, serif; padding-bottom: 4px;">
          <div style="font-weight: bold; font-size: 20px;">
            {{ results?.student_data?.pcb_mapping?.alias_1 || results?.student_data?.pcb_mapping?.alias_2 || results?.student_data?.pcb_mapping?.alias_3 }}
          </div>
          <div style="padding-top: 4px; font-weight: bold; font-size: 17px;">
            Examination ({{ results?.student_result_details?.exam_month }} - {{ results?.student_result_details?.exam_year }})
          </div>
          <div style="padding-top: 2px; font-weight: bold; font-size: 15px;">
            {{ results?.student_result_details?.semester_year }} (Batch : {{ results?.student_result_details?.batch }})
          </div>
        </div>

        <!-- ── Info section — table layout for exact colon alignment ─ -->
        <div class="info-section">
          <div class="info-left">
            <table style="border: none; border-collapse: collapse; margin-left: 4px;">
              <tr>
                <td style="font-family: 'Times New Roman', Times, serif; font-size: 14px; font-weight: bold; padding: 3px 0; white-space: nowrap; min-width: 155px;">Registration ID</td>
                <td style="font-family: 'Times New Roman', Times, serif; font-size: 14px; font-weight: bold; padding: 3px 10px; white-space: nowrap;">:</td>
                <td style="font-family: 'Courier New', Courier, monospace; font-size: 14px; font-weight: bold; padding: 3px 0; padding-left: 10px;">{{ results?.student_data?.admission_no }}</td>
              </tr>
              <tr>
                <td style="font-family: 'Times New Roman', Times, serif; font-size: 14px; font-weight: bold; padding: 3px 0; white-space: nowrap;">Name</td>
                <td style="font-family: 'Times New Roman', Times, serif; font-size: 14px; font-weight: bold; padding: 3px 10px;">:</td>
                <td style="font-family: 'Courier New', Courier, monospace; font-size: 14px; font-weight: bold; padding: 3px 0; padding-left: 10px; text-transform: uppercase;">{{ results?.student_result_details?.student_name }}</td>
              </tr>
              <tr>
                <td style="font-family: 'Times New Roman', Times, serif; font-size: 14px; font-weight: bold; padding: 3px 0; white-space: nowrap;">Father's Name</td>
                <td style="font-family: 'Times New Roman', Times, serif; font-size: 14px; font-weight: bold; padding: 3px 10px;">:</td>
                <td style="font-family: 'Courier New', Courier, monospace; font-size: 14px; font-weight: bold; padding: 3px 0; padding-left: 10px; text-transform: uppercase;">{{ results?.student_result_details?.student_father_name }}</td>
              </tr>
              <tr>
                <td style="font-family: 'Times New Roman', Times, serif; font-size: 14px; font-weight: bold; padding: 3px 0; white-space: nowrap;">Mother's Name</td>
                <td style="font-family: 'Times New Roman', Times, serif; font-size: 14px; font-weight: bold; padding: 3px 10px;">:</td>
                <td style="font-family: 'Courier New', Courier, monospace; font-size: 14px; font-weight: bold; padding: 3px 0; padding-left: 10px; text-transform: uppercase;">{{ results?.student_result_details?.student_mother_name }}</td>
              </tr>
            </table>
          </div>
          <div style="margin-top: 15px"><svg #barcode></svg></div>
        </div>

        <!-- ── Result table ────────────────────────────────────────── -->
        <table class="result-table">
          <thead>
          <tr>
            <th style="min-width: 88px; text-align: left; vertical-align: middle; padding: 4px 3px;">
              <div style="font-family: 'Times New Roman', Times, serif; font-size: 12px; font-weight: bold; line-height: 1.3;">SUBJECT<br>CODE</div>
            </th>
            <th style="min-width: 230px; text-align: left; vertical-align: middle; padding: 4px 3px;">
              <div style="font-family: 'Times New Roman', Times, serif; font-size: 12px; font-weight: bold;">SUBJECT NAME</div>
            </th>
            <th style="width: 65px; text-align: center; vertical-align: middle; padding: 4px 3px;">
              <div style="font-family: 'Times New Roman', Times, serif; font-size: 12px; font-weight: bold;">CREDIT</div>
            </th>
            <th style="width: 52px; text-align: center; vertical-align: middle; padding: 4px 3px;">
              <div style="font-family: 'Times New Roman', Times, serif; font-size: 12px; font-weight: bold;">GRADE</div>
            </th>
            <th style="width: 62px; text-align: center; vertical-align: middle; padding: 4px 3px;">
              <div style="font-family: 'Times New Roman', Times, serif; font-size: 12px; font-weight: bold; line-height: 1.3;">GRADE<br>POINT</div>
            </th>
            <th style="width: 62px; text-align: center; vertical-align: middle; padding: 4px 3px;">
              <div style="font-family: 'Times New Roman', Times, serif; font-size: 12px; font-weight: bold; line-height: 1.3;">TOTAL<br>GRADE<br>POINT</div>
            </th>
            <th style="width: 62px; text-align: center; vertical-align: middle; padding: 4px 3px;">
              <div style="font-family: 'Times New Roman', Times, serif; font-size: 12px; font-weight: bold;">STATUS</div>
            </th>
          </tr>
          </thead>
          <tbody>
          <tr *ngFor="let subject of results?.student_result_details?.student_result">
            <td style="text-align: left; padding: 3px 4px;">
              <p style="font-family: 'Times New Roman', Times, serif; margin: 0; font-size: 13px; font-weight: bold;">{{ subject?.code }}</p>
            </td>
            <td style="text-align: left; padding: 3px 4px;">
              <p style="font-family: 'Times New Roman', Times, serif; margin: 0; font-size: 13px; font-weight: bold;">{{ subject?.name }}</p>
            </td>
            <td style="text-align: center; padding: 3px 4px;">
              <p style="font-family: 'Times New Roman', Times, serif; margin: 0; font-size: 13px; font-weight: bold;">{{ subject?.credit }}</p>
            </td>
            <td style="text-align: center; padding: 3px 4px;">
              <p style="font-family: 'Times New Roman', Times, serif; margin: 0; font-size: 13px; font-weight: bold;">{{ subject?.grade?.trim() }}</p>
            </td>
            <td style="text-align: center; padding: 3px 4px;">
              <p style="font-family: 'Times New Roman', Times, serif; margin: 0; font-size: 13px; font-weight: bold;">{{ subject?.grade_points }}</p>
            </td>
            <td style="text-align: center; padding: 3px 4px;">
              <p style="font-family: 'Times New Roman', Times, serif; margin: 0; font-size: 13px; font-weight: bold;">{{ subject?.total_grade_points }}</p>
            </td>
            <td style="text-align: center; padding: 3px 4px;">
              <p style="font-family: 'Times New Roman', Times, serif; margin: 0; font-size: 13px; font-weight: bold;">{{ subject?.status }}</p>
            </td>
          </tr>
          <!-- Totals row -->
          <tr>
            <td colspan="2" style="text-align: center; border-right: none !important; padding: 4px 3px;">
              <p style="font-family: 'Times New Roman', Times, serif; margin: 0; font-size: 13px; font-weight: bold;">Total</p>
            </td>
            <td style="text-align: center; padding: 4px 3px;">
              <p style="font-family: 'Times New Roman', Times, serif; margin: 0; font-size: 13px; font-weight: bold;">{{ results?.student_result_details?.grand_total_credit }}</p>
            </td>
            <td></td>
            <td style="text-align: center; border-right: none !important; border-left: none !important; padding: 4px 3px;">
              <p style="font-family: 'Times New Roman', Times, serif; margin: 0; font-size: 13px; font-weight: bold;">{{ results?.student_result_details?.grand_total_grade_point }}</p>
            </td>
            <td style="text-align: center; padding: 4px 3px;">
              <p style="font-family: 'Times New Roman', Times, serif; margin: 0; font-size: 13px; font-weight: bold;">{{ results?.student_result_details?.grand_total_total_grade_point }}</p>
            </td>
            <td style="border-left: none !important;"></td>
          </tr>
          </tbody>
        </table>

        <!-- ── SGPA / CGPA footer ─────────────────────────────────── -->
        <div class="footer" style="margin-top: 6px !important;">
          <p style="text-align: right; margin-right: 10px; margin-bottom: 2px;">
            <span style="font-family: 'Times New Roman', Times, serif; font-size: 13px; font-weight: bold;">SEMESTER GRADE POINT AVERAGE (SGPA) : {{ results?.student_result_details?.sgpa }}</span>
          </p>
          <p style="text-align: right; margin-right: 10px; margin-bottom: 2px;">
            <span style="font-family: 'Times New Roman', Times, serif; font-size: 13px; font-weight: bold;">CUMULATIVE GRADE POINT AVERAGE (CGPA) : {{ results?.student_result_details?.cgpa }}</span>
          </p>
        </div>

      </div>
    </ng-container>
  </div>
  <ng-template #noDataToShow>
    <div class="flex justify-center items-center p-20px">
      <div
        class="card shadow-0 py-5 flex flex-col items-center text-center px-0 w-full sm:w-full md:w-full lg:w-full xl:w-full">
        <img src="../../../../../../assets/img/no-data-images/general.png" alt="Image" class="p-8 object-contain" />
        <h1 class="text-2xl font-bold p-4">Nothing to show here.</h1>
      </div>
    </div>
  </ng-template>
</div>
